import userData from "@/plugins/userData";

export default {
  name: "SideBar",
  mixins: [userData],
  data() {
    return {
      link: "dashboard",
      openedMenus: {},
      menuItems: [
        {
          name: "dashboard",
          path: "/dashboard",
          icon: "home",
          label: "Beranda",
          level: ["admin", "verificator", "kepala"],
        },
        {
          name: "permohonan-beasiswa",
          path: "/permohonan-beasiswa",
          icon: "money-bill-transfer",
          label: "Pengajuan",
          level: ["admin", "verificator"],
        },
        {
          name: "mahasiswa",
          path: "/mahasiswa",
          icon: "graduation-cap",
          label: "Mahasiswa",
          level: ["admin", "verificator"],
        },

        {
          name: "profil",
          path: "/profil",
          icon: "user",
          label: "Profil",
          level: ["user"],
        },
        {
          name: "pengajuan-beasiswa",
          path: "/pengajuan-beasiswa",
          icon: "money-bill-transfer",
          label: "Pengajuan",
          level: ["user"],
        },
        {
          name: "master",
          icon: "cogs",
          label: "Administrator",
          level: ["admin"],
          children: [
            {
              name: "pengguna",
              path: "/pengguna",
              icon: "user-shield",
              label: "Pengguna",
              level: ["admin"],
            },
            {
              name: "verifikasi",
              path: "/verifikasi",
              icon: "user-shield",
              label: "Verifikasi NIK",
              level: ["admin"],
            },
            {
              name: "cek-penerima-beasiswa",
              path: "/cek-penerima-beasiswa",
              icon: "magnifying-glass",
              label: "Cek Penerima Beasiswa",
              level: ["admin"],
            },
            {
              name: "pengaturan",
              path: "/pengaturan",
              icon: "cog",
              label: "Pengaturan",
              level: ["admin"],
            },
            // {
            //   name: "master-schemes",
            //   path: "/master/schemes",
            //   icon: "file-lines",
            //   label: "Skema",
            // },
          ],
        },
      ],
    };
  },
  computed: {
    userLevel() {
      return this.$store.state.userLevel || "user";
    },
    filteredMenuItems() {
      return this.menuItems.filter((item) =>
        item.level.includes(this.userLevel),
      );
    },
    activeParentMenus() {
      const active = new Set();
      for (const item of this.menuItems) {
        if (item.children) {
          for (const child of item.children) {
            if (this.link === child.name) {
              active.add(item.name);
            }
          }
        }
      }
      return active;
    },
  },
  mounted() {
    // Inisialisasi openedMenus untuk semua menu yang memiliki children
    this.menuItems.forEach((item) => {
      if (item.children) {
        this.openedMenus[item.name] = this.activeParentMenus.has(item.name);
      }
    });

    // Initialize Flowbite untuk dropdown
    this.$nextTick(() => {
      if (window.initFlowbite) {
        window.initFlowbite();
      }
    });
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(newValue) {
        const pathSegments = newValue.split("/").filter((seg) => seg);
        const pathName =
          pathSegments.length > 0 ? pathSegments[0] : "dashboard";

        // Cek apakah path cocok dengan child menu
        let matchedChildName = null;
        let matchedParentName = null;

        for (const item of this.menuItems) {
          if (item.children) {
            const matchedChild = item.children.find(
              (child) => child.path === newValue,
            );
            if (matchedChild) {
              matchedChildName = matchedChild.name;
              matchedParentName = item.name;
              break;
            }
          }
        }

        // Tutup semua menu yang memiliki submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }

        // Buka parent menu jika ada child yang cocok
        if (matchedParentName) {
          this.openedMenus[matchedParentName] = true;
        }

        // Set link ke child name jika ada, atau ke path name
        this.link = matchedChildName || pathName;
        this.closeSidebarOnMobile();
      },
    },
  },
  methods: {
    toggleMenu(menuName) {
      const menuItem = this.menuItems.find((item) => item.name === menuName);

      // Jika menu yang diklik memiliki children (submenu)
      if (menuItem && menuItem.children) {
        const wasOpen = this.openedMenus[menuName];

        // Tutup semua menu yang memiliki submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }

        // Toggle menu yang diklik
        this.openedMenus[menuName] = !wasOpen;
        this.link = menuName;
      } else {
        // Jika menu tanpa children diklik, tutup semua submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }
        this.link = menuName;
      }
    },
    closeSidebarOnMobile() {
      // Cek apakah dalam mode mobile (sidebar tersembunyi di desktop)
      const sidebar = document.getElementById("logo-sidebar");
      if (sidebar && window.innerWidth < 640) {
        // 640px = sm breakpoint Tailwind
        sidebar.classList.add("-translate-x-full");

        // Optional: Scroll ke atas halaman dengan smooth
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
